export const BANK_NAME = 'bank_name';
export const PASSBOOK_PIC = 'passbook_pic';



// WEBPACK FOOTER //
// ./app/constants/bankField.js